import { Injectable } from '@angular/core';
import { CompanyActions, OccCompanyService } from '@company/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class RemoveCompanyEffects {
  removeCompany$: Observable<CompanyActions.RemoveCompanySuccess | CompanyActions.RemoveCompanyFail> = createEffect(
    () =>
      this.actions$.pipe(
        ofType<CompanyActions.RemoveCompany>(CompanyActions.REMOVE_COMPANY),
        switchMap((action) => {
          return this.occCompanyService.removeCompany(action.payload).pipe(
            map(() => new CompanyActions.RemoveCompanySuccess(action.payload)),
            catchError(() => of(new CompanyActions.RemoveCompanyFail())),
          );
        }),
      ),
  );

  constructor(
    private actions$: Actions,
    private occCompanyService: OccCompanyService,
  ) {}
}
